function convertTimeStringToDate (timeString)  {
    if (!timeString || timeString === "00:00:00") {
        return null; 
    }
    
 
    const parts = timeString.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const seconds = parseInt(parts[2], 10);

   
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0); 
    
    return date;
};

export default convertTimeStringToDate;

